// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert[data-v-70b74c1a]{padding:12px 15px;margin-bottom:20px;background:linen;border-left:10px solid #f37053}.alert a[data-v-70b74c1a]{color:#333;text-decoration:underline}.alert a[data-v-70b74c1a]:hover{text-decoration:none}.alert[data-v-70b74c1a]:empty{display:none}@media (min-width:1024px){.alert[data-v-70b74c1a]{padding:20px 30px;margin-bottom:30px;font-weight:700}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
